var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2875 51L45.9 43.35V58.65L59.2875 51Z",
    fill: "#919BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 51C0 22.8335 22.8335 0 51 0C79.1665 0 102 22.8335 102 51C102 79.1665 79.1665 102 51 102C22.8335 102 0 79.1665 0 51ZM70.7625 34.1063C72.9938 34.7438 74.5875 36.3375 75.225 38.5688C76.5 42.7125 76.5 51 76.5 51C76.5 51 76.5 59.2875 75.5438 63.4313C74.9063 65.6625 73.3125 67.2563 71.0812 67.8938C66.9375 68.85 51 68.85 51 68.85C51 68.85 34.7437 68.85 30.9187 67.8938C28.6875 67.2563 27.0938 65.6625 26.4563 63.4313C25.5 59.2875 25.5 51 25.5 51C25.5 51 25.5 42.7125 26.1375 38.5688C26.775 36.3375 28.3688 34.7438 30.6 34.1063C34.7438 33.15 50.6812 33.15 50.6812 33.15C50.6812 33.15 66.9375 33.15 70.7625 34.1063Z",
    fill: "#919BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b740e873a907215f3d8a349735e4ec6f.svg";
export { ForwardRef as ReactComponent };